export class RecoveryController {
    constructor({
        windowLike,
        logger,
        maxAttempts,
        baseDelayMs,
        onScheduled,
        onExhausted,
        onRecover,
        isSessionCurrent,
    }) {
        this.window = windowLike;
        this.logger = logger;
        this.maxAttempts = maxAttempts;
        this.baseDelayMs = baseDelayMs;
        this.onScheduled = onScheduled;
        this.onExhausted = onExhausted;
        this.onRecover = onRecover;
        this.isSessionCurrent = isSessionCurrent;
        this.attempts = 0;
        this.timer = null;
    }

    schedule(error, sessionToken, metadata = {}) {
        if (this.timer) {
            return;
        }

        if (this.attempts >= this.maxAttempts) {
            this.logger.fatal(
                'scanner.recovery.exhausted',
                'A retomada automática atingiu o limite de tentativas.',
                error,
                {
                    attempts: this.attempts,
                    requestedBy: metadata.requestedBy || null,
                    component: metadata.component || null,
                    health: metadata.health || null,
                    exception: metadata.exception || null,
                }
            );
            this.onExhausted?.(error);
            return;
        }

        this.attempts++;
        const delay = this.baseDelayMs * this.attempts;
        const scheduled = {
            attempt: this.attempts,
            delay,
        };

        if (metadata.requestedBy) {
            scheduled.requestedBy = metadata.requestedBy;
        }

        if (metadata.component) {
            scheduled.component = metadata.component;
        }

        this.onScheduled?.(scheduled);
        this.logger.warn(
            'scanner.recovery.scheduled',
            `Retomada automática agendada (tentativa ${this.attempts}).`,
            {
                delay,
                reason: error.message,
                requestedBy: metadata.requestedBy || null,
                component: metadata.component || null,
                health: metadata.health || null,
                exception: metadata.exception || null,
            }
        );

        this.timer = this.window.setTimeout(async () => {
            this.timer = null;

            if (!this.isSessionCurrent(sessionToken)) {
                return;
            }

            await this.onRecover(sessionToken);
        }, delay);
    }

    clear() {
        if (this.timer) {
            this.window.clearTimeout(this.timer);
            this.timer = null;
        }
    }

    reset() {
        this.clear();
        this.attempts = 0;
    }
}
